<template>
    <div>
        <v-form v-model="valid">
            <v-container class="d-flex align-center justify-center" style="width:100%">
                <v-row>
                    <v-col class="d-flex align-center justify-center">

                        <v-file-input id="fileInput" ref="fileInput" :rules='fileRules' accept=".kml,.kmz" outlined v-model="km" :placeholder="$t('provider_dashboard.field_kmz')" :label="$t('provider_dashboard.label_km')" prepend-icon="" :disabled="loading" prepend-inner-icon="mdi-map-marker-plus-outline">

                        </v-file-input>

                        <v-btn :loading='loading' :disabled='!provider._id || !valid || !km' color="green" @click="saveKM" class="white--text mb-8 ml-2 btn-upload">
                            <v-icon>mdi-upload</v-icon>
                        </v-btn>

                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <v-dialog v-model="dialog" persistent max-width='900px'  class="d-flex">
     
                <v-app-bar color="primary" dense dark>

                    <v-toolbar-title>{{$t('coverage_areas')}}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon text @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                </v-app-bar>

                <v-card>

                    <PreviewAreaTableData :areas="previewAreas ? previewAreas : []" :provider="provider" :itemKey="'tempId'" @saved='areasSaved' />

                </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { SAVE_KM, SET_PREVIEW_AREAS } from '../../../../store/mutations';
import validators from '../../../../utils/validators';
import PreviewAreaTableData from './PreviewAreaTableData.vue'

export default {
    name: 'Uploader',
    data() {
        return {
            km: null,
            valid: false,
            dialog: false,
            loading: null,
            fileRules: [
                            v => validators.file.only_km(v) || this.$t('validators.file.img'),
                ],
        }
    },

    components: { PreviewAreaTableData },

    computed: {

        ...mapGetters({ provider: 'ProviderVuex/provider', previewAreas: 'AreaVuex/preview_areas'}),

    },

    methods: {

        ...mapActions({ upKm: `AreaVuex/${SAVE_KM}` }),

        ...mapMutations({ setPreviewAreas: `AreaVuex/${SET_PREVIEW_AREAS}` }),

        async saveKM() {     

                if (!this.km) return this.showToast(this.$t('provider_register.toast_kmz_error_msg'), this.$t('provider_register.toast_kmz_error_title'), 'error')

                this.loading = true;

                let loader = this.$loading.show({ 'is-full-page': true, color: 'green' }); 

                try {

                        const areas = await this.upKm({ km: this.km, id: this.provider._id, name: this.provider.name })
                        
                        this.$emit('kmup')

                        this.setPreviewAreas(this.patchTempId(areas))

                        this.dialog = true

                        return this.showToast(this.$t('provider_register.toast_kmz_update_msg'), this.$t('provider_register.toast_kmz_update_title'), 'success')

                } catch (error) {

                        console.log(error)

                        this.$emit('kmtryfail')
               
                        return this.showToast(error.message, this.$t('provider_register.toast_kmz_error_update_title'), 'warning')

                } finally {

                        this.loading = false;
                        this.km = null;
                        loader.hide();

                }

        },

        areasSaved() {

            this.dialog = false
            this.$emit('saved')


        },

        patchTempId(areas) {

            let count = 0

            return areas.map(area => {

                count++

                area.tempId = count

                return area

            })


        }
    },

}
</script>

<style>

</style>